import { Injectable, QueryList } from '@angular/core';
import { PublishingStepComponent } from '@app/features/app-publishing/components/publishing-step/publishing-step.component';
import { PublishingStepStatus } from '@app/features/app-publishing/models/publishing.model';

@Injectable({
  providedIn: 'root',
})
export class FlowLinesService {
  updateFlowLines(stepComponents: QueryList<PublishingStepComponent>): void {
    const steps = stepComponents.toArray();

    steps.forEach((step, index) => {
      const isLastStep = index === steps.length - 1;

      step.isLastStep = isLastStep;
      step.showFlowLine = !isLastStep;
      step.flowLineCompleted = this.isStepCompleted(step.status);
    });
  }

  private isStepCompleted(status: PublishingStepStatus): boolean {
    return status === 'completed';
  }
}
